import { useState } from "react";
import { ChoiceChips } from "@/components/ChoiceChips";
import { Label } from "@/components/ui/label";

/**
 * What you are to an artist, asked at the point you join their legacy.
 *
 * Relationship is a property of the member-to-legacy link, so accepting an
 * invitation without one makes the only kind of link that cannot answer the
 * question. The registration form used to carry that debt: it listed every
 * legacy already on the profile and asked about each, which is a question
 * belonging to the legacies page rather than to an application.
 *
 * Held here rather than saved on each click, because there is nothing to save
 * against until the invitation is accepted.
 */
export function useInviteRelationship() {
  const [relationship, setRelationship] = useState<string[]>([]);
  const [other, setOther] = useState("");
  return {
    relationship,
    other,
    /** Nothing chosen is nothing to send: the server refuses it either way. */
    ready: relationship.length > 0,
    reset: () => {
      setRelationship([]);
      setOther("");
    },
    field: (options: string[]) => (
      <div className="space-y-2">
        <Label>Your relationship to the artist or entity *</Label>
        <ChoiceChips
          options={options}
          value={relationship}
          onChange={setRelationship}
          other={other}
          onOtherChange={setOther}
        />
      </div>
    ),
  };
}
